import React from "react";
import { Checkbox } from "@americanexpress/dls-react";
import FormField from "../../Common/FormField";
import { useCountry } from "../CountryContext";
import { useTranslation } from "react-i18next";
import { INFO_FIELDS } from "../../Common/constants";
import { getInfoFields } from "../../Common/utils";

const CorrespondenceInfoSection = ({ formik, country }) => {
  const { t } = useTranslation("common");
  const { isModifyUser, userIndex } = useCountry();
  const checkboxId = userIndex !== undefined
    ? `modifypaPermissionOnline_${userIndex}`
    : "modifypaPermissionOnline";
  const correspondenceInfoFields = getInfoFields(country, INFO_FIELDS.CORRESPONDENCEINFO, t);
  const countriesToSkipCorrespondenceDetails = new Set([t(`access.INTERNATIONALEUROCARD`)]);

  return (
    <section id="correspondence-info">
      <div className="row">
        {!isModifyUser && (
          <FormField
            id="empBussName"
            name="empBussName"
            label={correspondenceInfoFields.employerCompanyName}
            value={formik.values.empBussName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            hint={t("newuser.provideIfDifferentThanRegisteredName")}
            error={formik.touched.empBussName && formik.errors.empBussName}
          />
        )}
        <FormField
          id="corrAddress"
          name="corrAddress"
          label={t("newuser.correspondenceAddress")}
          value={formik.values.corrAddress}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          hint={t("newuser.provideIfDifferentThanRegisteredAddress")}
          error={formik.touched.corrAddress && formik.errors.corrAddress}
        />
        <FormField
          id="corrPostcode"
          name="corrPostcode"
          label={t("newuser.correspondencePostalCode")}
          value={formik.values.corrPostcode}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.corrPostcode && formik.errors.corrPostcode}
        />
        <FormField
          id="corrCountry"
          name="corrCountry"
          label={t("newuser.correspondenceCountry")}
          value={formik.values.corrCountry}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.corrCountry && formik.errors.corrCountry}
        />
        {isModifyUser && !countriesToSkipCorrespondenceDetails.has(country) &&
          <Checkbox
            id={checkboxId}
            name="modifypaPermissionOnline"
            label={t("modifyuser.paPermissionOnlineCheckbox")}
            checked={formik.values.modifypaPermissionOnline}
            onChange={formik.handleChange}
          />
        }
      </div>
    </section>
  );
};

export default CorrespondenceInfoSection;
